import React, {useState, useEffect, useContext} from "react";
import {UserContext} from "../App";

export default function User(props) {
  const userf = useContext(UserContext);
  const [user, setUser] = useState(null);

  const [role, setRole] = useState(null);




  useEffect(() => {


  }, []);

  if (!userf) {
    return "loading...";
  }

  return (
    <div>
      {userf && userf.rights}
    </div>
  );
}
